const SmtpSettingsAdmin = () =>
  <>
    You do not have permission to view this content. Contact your administrator for access.
  </>

export default SmtpSettingsAdmin
